import React from 'react';
import styles from './calendarBtn.css';
import CalendarVariantIcon from '../../../../assets/svg/calendarVariant.svg';
import ChevronIcon from '../../../../assets/svg/chevron.svg';

/**
 *
 * @type {React.NamedExoticComponent<{readonly onclick?: *, readonly caption?: *}>}
 */
const CalendarBtn = React.memo( ( { onclick, caption } ) => {
    return (
        <a onClick={ onclick } className={ styles.calendar }>
            <CalendarVariantIcon className={ styles.iconCalendar }/>
            <span>{ caption }</span>
            <ChevronIcon className={ styles.iconChevron }/>
        </a>
    );
} );

export default CalendarBtn;
